<template>
  <div :class="[$style.notice, fullScreen && $style.fullScreen]">
    <div :class="$style.updateContent">
      <!-- 登录后强更 -->
      <div :class="$style.noticeTitle">
        <span>{{ noticeData.show_title }}</span>
      </div>
      <div :class="[$style.updateText, !noticeData.gift_icon || !noticeData.gift_icon.length ? $style.noGift : '']">
        <img :src="`${$cdnLink}/update/fangkuai.png`" alt />
        <span>{{ noticeData.show_text }}</span>
      </div>
      <div :class="$style.pass">
        <p><span :class="$style.text">账号：{{ username }} </span><span :class="[$style.copyLink, 'copy-btn']"  :data-clipboard-text="username">复制</span></p>
        <p><span :class="$style.text">密码：{{ password }} </span><span :class="[$style.copyLink, 'copy-btn']"  :data-clipboard-text="password">复制</span></p>   
      </div>
      <div :class="$style.updateGift" v-show="noticeData.gift_icon && noticeData.gift_icon.length">
        <p :class="$style.giftSubTitle">版本更新奖励</p>
        <p :class="$style.giftSubDesc">新版本已经发布，下载并登录全新客户端后，即可<span>免费领取以下奖励</span></p>
        <div :class="$style.giftImg">
          <img :src="item" v-for="(item, index) in noticeData.gift_icon" :key="index" />
        </div>
      </div>
      <p :class="[$style.copyLink, 'copy-btn']"  :data-clipboard-text="noticeData.game_url">点击此处，可手动复制更新链接</p>
      <p :class="$style.updateHint">
        注意：更新过程中<span>请勿卸载游戏</span>，避免影响您的正常账户数据，如若无法从旧版客户端进入游戏或其他问题，请
        <span :class="$style.contactKf" @click="contact">联系客服</span>。
      </p>
      <div :class="$style.btnGroup" v-if="!process && !specialPack">
        <div :class="$style.notUpdata" @click="closeHintShow = true" v-show="closeAble == '1'">暂不更新</div>
        <div :class="$style.doUpdata" @click="doUpdata">立即更新</div>
      </div>
      <div :class="$style.downloadProcess" v-if="process">
        <span :class="$style.back"></span>
        <span :class="$style.process" :style="{ width: `${process}%` }"></span>
        <img :src="`${$cdnLink}/update/process.png?v=1`" alt="" :class="$style.icon" :style="{ left: `${process - 2}%` }" >
        <span :class="$style.text" :style="{ left: `${process - 3}%` }">{{ process }}%</span>
      </div>
    </div>
    <div :class="$style.closeHint" v-show="closeHintShow">
      <h1>确认不更新吗</h1>
      <p>
        因当前所在版本暂停维护，如若未及时进行更新，将会影响您正常的游戏体验，后续可能还会出现<span>登录异常</span>、<span>账号丢失</span>等情况。
      </p>
      <p>请点击下方更新按钮，给您带来的不变还请多谅解。</p>
      <div :class="$style.closeBtn">
        <img :src="`${$cdnLink}/update/btn1.png?v=1`" alt :class="$style.notUpdata" @click="notUpdata" />
        <img :src="`${$cdnLink}/update/btn.png?v=1`" alt :class="$style.doUpdata" @click="doUpdata" />
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import { gameOpenDownloads, notifyDownloadProgress, doDownloadFile } from '@/bridge/AppJsBridge';
import { versionCompare, getStorage, isAndroid } from '@/libs/utils';
import isFullScreen from '@/libs/business/fullScreen';
import Clipboard from "clipboard";
import { getAccount } from '@/libs/utils'

export default {
  data() {
    return {
      closeHintShow: false,
      process: 0,
      fullScreen: '',
      username: '',
      password: '',
      specialPack: false
    };
  },
  created() {
    this.fullScreen = isFullScreen();
  },
  mounted() {
    this.handleSpecialPack();
    this.processListener()
    this.copyInit()
    this.getUserList();
  },
  computed: {
    ...mapState({
      noticeData: state => state.user.force_update_info
    }),
    closeAble() {
      // 后台控制是否可关闭开关判断
      return this.noticeData && this.noticeData['closeable'];
    },
  },
  methods: {
    ...mapActions({
      openCustomer: 'global/openCustomer',
    }),
    async getUserList() {
      this.userList = getAccount();
      if (this.userList && this.userList.length)  {
        this.username = this.userList[0].username;
        this.password = this.userList[0].password;
      }
    },
    handleSpecialPack() {
      const appkey = getStorage('appkey');
      if (appkey == '200012237') {
        this.specialPack = true;
      }
    },
    // 暂不更新
    notUpdata: function () {
      sessionStorage.setItem('close_update', 1);
      this.$store.commit('user/CHANGE_STATE', { forceUpdateVisible: false});
    },
    copyInit() {
      this.copy = new Clipboard('.copy-btn');
      this.copy.on('success', (e) => {
        this.$toast('复制成功');
      });
    },
    // 更新
    doUpdata: function () {
      const device_info = getStorage('device_info');
      if (isAndroid() && versionCompare(device_info.sdkVersion, '4.1.0')) {
        doDownloadFile({ url: this.noticeData.game_url})
      } else {
        this.$toast({
          duration: 3000,
          message: '请点击本界面或默认浏览器底部的下载标识进行游戏更新。请在手机默认浏览器查看下载内容哦',
        });
        setTimeout(() => {
          gameOpenDownloads({
            gameUrl: this.noticeData.game_url,
          });
        }, 3000);
      }
    },
    contact() {
      this.openCustomer();
    },
    processListener() {
      notifyDownloadProgress((process, cb) => {
        this.process = process;
      })
    }
  },
};
</script>

<style module lang="scss">
.notice {
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0;
  top: 0;
  z-index: 999;
  background: #ffffff;
  overflow: auto;
  font-size: 0;
  .updateContent {
    width: 100%;
    height: 100%;
  }
  .noticeTitle {
    width: 100%;
    height: 0.8rem;
    color: #ff4f3e;
    font-weight: 500;
    font-style: italic;
    font-size: 0.3rem;
    line-height: 0.8rem;
    padding-left: 0.15rem;
    box-sizing: border-box;
    background: url('//static.52ywan.com/Lianyun/SdkImg/update/header.png') no-repeat;
    background-size: 100% 100%;
  }
  .updateText {
    display: flex;
    align-items: flex-start;
    margin-top: 0.08rem;
    padding: 0 0.2rem;
    &.noGift {
      margin-top: 0.2rem;
      padding: 0 0.4rem;
      height: 1.9rem;
      > span {
        font-size: 0.3rem;
        line-height: 0.35rem;
      }
    }
    > img {
      width: 0.15rem;
      height: 0.15rem;
      margin: 0.03rem 0.05rem 0 0.02rem;
    }
    > span {
      font-size: 0.21rem;
      line-height: 0.23rem;
    }
  }
  .pass {
    text-align: center;
    font-size: .25rem;
    margin-bottom: .2rem;
    .text {
      text-align: left;
      display: inline-block;
      width: 2.4rem;
      margin-bottom: .1rem;
    }
    .copyLink {
      margin-left: 0;
    }
  }
  .updateGift {
    width: 6.73rem;
    height: 2.52rem;
    margin: auto {
      top: 0.15rem;
    }
    background: #f5f3f0;
    border-radius: 0.04rem;
    .giftSubTitle {
      font-size: 0.25rem;
      color: #ff503f;
      text-align: center;
      font-weight: bold;
      padding-top: 0.13rem;
      margin-bottom: 0.2rem;
    }
    .giftSubDesc {
      color: #958681;
      font-size: 0.19rem;
      margin-bottom: 0.19rem;
      text-align: center;
      line-height: 0.19rem;
      > span {
        color: #ff503f;
      }
    }
    .giftImg {
      display: flex;
      justify-content: center;
      > img {
        width: 1rem;
        max-height: 1.4rem;
        margin: 0 0.05rem;
      }
    }
  }
  .copyLink {
    color: #ff503f;
    font-size: 0.2rem;
    margin: {
      top: .1rem;
      left: .4rem;
    }
    text-decoration: underline;
  }
  .updateHint {
    color: #999999;
    font-size: 0.2rem;
    line-height: 0.24rem;
    padding: 0 0.2rem;
    margin: 0.2rem 0.2rem 0.1rem 0.2rem;
    > span {
      color: #ff503f;
    }
    .contactKf {
      text-decoration: underline;
    }
  }
  .btnGroup {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    .notUpdata {
      width: 2.5rem;
      height: 0.6rem;
      background-color: #999999;
      color: #ffffff;
      border-radius: 0.6rem;
      font-size: 0.25rem;
      text-align: center;
      line-height: 0.6rem;
      margin-right: 0.2rem;
    }
    .doUpdata {
      width: 2.5rem;
      height: 0.6rem;
      background: linear-gradient(90deg, #ff6c5e 0%, #ff6254 100%);
      box-shadow: 0px 10px 35px 0px rgba(255, 98, 84, 0.45);
      color: #ffffff;
      border-radius: 0.6rem;
      font-size: 0.25rem;
      text-align: center;
      line-height: 0.6rem;
      margin-left: 0.2rem;
    }
  }
  .closeHint {
    position: absolute;
    left: 0;
    top: 0;
    bottom: 0;
    right: 0;
    margin: auto;
    width: 6rem;
    height: 3.8rem;
    background: #ffffff;
    box-shadow: 0px 2px 14px 0px rgba(0, 0, 0, 0.33);
    border-radius: 7px;
    padding: 0.3rem 0.32rem;
    box-sizing: border-box;
    > h1 {
      font-size: 0.28rem;
      font-weight: bold;
      color: #ff5141;
      line-height: 0.12rem;
      text-align: center;
      margin-bottom: 0.18rem;
    }
    > p:nth-child(2) {
      font-size: 0.22rem;
      color: #333333;
      margin-bottom: 0.28rem;
      font-weight: 400;
      > span {
        color: #ff5141;
      }
    }
    > p:nth-child(3) {
      font-size: 0.2rem;
      color: #636363;
    }
    .closeBtn {
      margin-top: 0.5rem;
      display: flex;
      justify-content: space-evenly;
      align-items: flex-end;
      > img:nth-child(1) {
        width: 2.32rem;
        height: 0.66rem;
      }
      > img:nth-child(2) {
        width: 2.52rem;
        height: 0.75rem;
      }
    }
  }
  .downloadProcess {
    position: relative;
    width: 90%;
    height: 14px;
    margin: auto {
      top: 25px;
    };
    .back {
      display: inline-block;
      width: 100%;
      height: 100%;
      background: #f3f3f3;
      border-radius: 15px;
    }
    .process {
      display: inline-block;
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      border-radius: 15px 0 0 15px;
      background: #ff4f3e;
    }
    .icon {
      width: 18px;
      height: 18px;
      position: absolute;
      top: -2.5px;
    }
    .text {
      font-size: 8px;
      background: #ff4f3e;
      color: #FFFFFF;
      border-radius: 12px;
      padding: 2px 4px;
      position: absolute;
      top: -18px;
    }
  }

  &.fullScreen {
    width: 100%;
    height: 100%;
    position: absolute;
    left: 0;
    top: 0;
    z-index: 999;
    overflow: auto;
    font-size: 0;
    background: rgba(0, 0, 0, 0.4);
    .updateContent {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      margin: auto;
      width: 96%;
      height: 5.7rem;
      background: #ffffff;
      border-radius: 0.06rem;
      @media screen and (orientation: landscape) {
        width: 3.8rem;
        height: 2.8rem;
      }
    }
    .noticeTitle {
      width: 100%;
      height: 0.8rem;
      color: #ff4f3e;
      font-weight: 500;
      font-style: italic;
      font-size: 0.3rem;
      line-height: 0.8rem;
      padding-left: 0.15rem;
      background: url('//static.52ywan.com/Lianyun/SdkImg/update/header.png') no-repeat;
      background-size: 100% 100%;
      @media screen and (orientation: landscape) {
        width: 100%;
        height: 0.4rem;
        font-size: 0.15rem;
        line-height: 0.4rem;
        padding-left: 0.07rem;
      }
    }
    .updateText {
      display: flex;
      align-items: flex-start;
      margin-top: 0.08rem;
      padding: 0 0.2rem;
      &.noGift {
        margin-top: 0.8rem;
        padding: 0 0.4rem;
        height: 2.2rem;
        @media screen and (orientation: landscape) {
          margin-top: 0.4rem;
          padding: 0 0.2rem;
          height: 1.1rem;
        }
        > span {
          font-size: 0.3rem;
          line-height: 0.35rem;
          @media screen and (orientation: landscape) {
            font-size: 0.15rem;
            line-height: 0.17rem;
          }
        }
      }
      @media screen and (orientation: landscape) {
        margin-top: 0.04rem;
        padding: 0 0.1rem;
      }
      > img {
        width: 0.15rem;
        height: 0.15rem;
        margin: 0.03rem 0.05rem 0 0.02rem;
        @media screen and (orientation: landscape) {
          width: 0.07rem;
          height: 0.07rem;
          margin: 0.015rem 0.025rem 0 0.01rem;
        }
      }
      > span {
        font-size: 0.21rem;
        line-height: 0.23rem;
        @media screen and (orientation: landscape) {
          font-size: 0.1rem;
          line-height: 0.11rem;
        }
      }
    }
    .updateGift {
      width: 6.73rem;
      height: 2.52rem;
      margin: auto {
        top: 0.15rem;
      }
      background: #f5f3f0;
      border-radius: 0.04rem;
      @media screen and (orientation: landscape) {
        width: 3.36rem;
        height: 1.26rem;
        margin: auto {
          top: 0.07rem;
        }
        border-radius: 0.02rem;
      }
      .giftSubTitle {
        font-size: 0.25rem;
        color: #ff503f;
        text-align: center;
        font-weight: bold;
        padding-top: 0.13rem;
        margin-bottom: 0.2rem;
        @media screen and (orientation: landscape) {
          font-size: 0.12rem;
          padding-top: 0.06rem;
          margin-bottom: 0.1rem;
        }
      }
      .giftSubDesc {
        color: #958681;
        font-size: 0.19rem;
        margin-bottom: 0.19rem;
        text-align: center;
        line-height: 0.19rem;
        @media screen and (orientation: landscape) {
          font-size: 0.09rem;
          margin-bottom: 0.09rem;
          line-height: 0.09rem;
        }
        > span {
          color: #ff503f;
        }
      }
      .giftImg {
        display: flex;
        justify-content: center;
        > img {
          width: 1rem;
          max-height: 1.5rem;
          margin: 0 0.05rem;
          @media screen and (orientation: landscape) {
            width: 0.5rem;
            max-height: 0.75rem;
            margin: 0 0.02rem;
          }
        }
      }
    }

    .updateHint {
      color: #999999;
      font-size: 0.2rem;
      line-height: 0.24rem;
      padding: 0 0.2rem;
      margin: 0.4rem 0.2rem 0.1rem 0.2rem;
      @media screen and (orientation: landscape) {
        font-size: 0.1rem;
        line-height: 0.12rem;
        padding: 0 0.1rem;
        margin: 0.2rem 0rem 0.05rem 0rem;
      }
      > span {
        color: #ff503f;
      }
      .contactKf {
        text-decoration: underline;
      }
    }
    .btnGroup {
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      .notUpdata {
        width: 2.5rem;
        height: 0.6rem;
        background-color: #999999;
        color: #ffffff;
        border-radius: 0.6rem;
        font-size: 0.25rem;
        text-align: center;
        line-height: 0.6rem;
        margin-right: 0.2rem;
        @media screen and (orientation: landscape) {
          width: 1.25rem;
          height: 0.3rem;
          border-radius: 0.3rem;
          font-size: 0.12rem;
          line-height: 0.3rem;
          margin-right: 0.1rem;
        }
      }
      .doUpdata {
        width: 2.5rem;
        height: 0.6rem;
        background: linear-gradient(90deg, #ff6c5e 0%, #ff6254 100%);
        box-shadow: 0px 10px 35px 0px rgba(255, 98, 84, 0.45);
        color: #ffffff;
        border-radius: 0.6rem;
        font-size: 0.25rem;
        text-align: center;
        line-height: 0.6rem;
        margin-left: 0.2rem;
        @media screen and (orientation: landscape) {
          width: 1.2rem;
          height: 0.3rem;
          background: linear-gradient(90deg, #ff6c5e 0%, #ff6254 100%);
          box-shadow: 0px 10px 35px 0px rgba(255, 98, 84, 0.45);
          color: #ffffff;
          border-radius: 0.3rem;
          font-size: 0.12rem;
          text-align: center;
          line-height: 0.3rem;
          margin-left: 0.1rem;
        }
      }
    }
    .closeHint {
      @media screen and (orientation: landscape) {
        position: absolute;
        left: 0;
        top: 0;
        bottom: 0;
        right: 0;
        margin: auto;
        width: 3rem;
        height: 1.9rem;
        background: #ffffff;
        box-shadow: 0px 2px 14px 0px rgba(0, 0, 0, 0.33);
        border-radius: 7px;
        padding: 0.15rem 0.16rem;
        box-sizing: border-box;
        > h1 {
          font-size: 0.14rem;
          font-weight: bold;
          color: #ff5141;
          line-height: 0.06rem;
          text-align: center;
          margin-bottom: 0.09rem;
        }
        > p:nth-child(2) {
          font-size: 0.11rem;
          color: #333333;
          margin-bottom: 0.15rem;
          font-weight: 400;
        }
        > p:nth-child(3) {
          font-size: 0.1rem;
          color: #636363;
        }
        .closeBtn {
          margin-top: 0.25rem;
          display: flex;
          justify-content: space-evenly;
          align-items: flex-end;
          > img:nth-child(1) {
            width: 1.16rem;
            height: 0.33rem;
          }
          > img:nth-child(2) {
            width: 1.26rem;
            height: 0.37rem;
          }
        }
      }
    }
  }
}
</style>

/* 显示username password */
